/**
 * Permissions that always send a plugin submission to a human reviewer,
 * whatever its risk score — the review service's `sensitive_permission` gate.
 *
 * A copy of `HUMAN_REVIEW_REQUIRED_PERMISSIONS` in `@fias/db-types`, which the
 * gate reads (the client does not depend on `@fias/db-types`). The submission
 * page uses it to explain an escalation; a stale copy would tell a contributor
 * their plugin was held for its score when it was held for a permission.
 * Pinned equal by `tests/architecture/human-review-permissions-client-parity.test.ts`.
 *
 * Imports nothing, so the architecture test can load it directly.
 */
export const HUMAN_REVIEW_REQUIRED_PERMISSIONS: readonly string[] = [
  'vault:user-documents:read',
  'vault:user-documents:write',
  'vault:user-documents:edit',
  'vault:arche-saves:write',
  'vault:workspace-documents:read',
  'vault:creative:read',
  'vault:creative:write',
  'docsign:envelopes:read',
  'email:company:send',
  'connections:use',
];
